import { computed, Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

	public allData = computed(() => {
		this.refetchData();
		return { ...localStorage };
	});
	private refetchData = signal(0);

	updateData(key: string, value: string) {
		localStorage.setItem(key, value);
		this.refetchData.set(this.refetchData() + 1);
	}

	deleteData(key: string) {
		localStorage.removeItem(key);
		this.refetchData.set(this.refetchData() + 1);
	}
	
	clearAll() {
		localStorage.clear();
		this.refetchData.set(this.refetchData() + 1);
	}
}